import React, { useState, useEffect } from 'react';

const PrototypePage: React.FC = () => {
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());

  // Timer für die Live-Uhr
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md mb-6">
          <h1 className="text-3xl font-bold text-center text-blue-600 mb-4">
            Dentalytics Dashboard
          </h1>
          <p className="text-center text-gray-600 mb-6">
            Analytics-Plattform für Zahnarztpraxen
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
              <h3 className="font-semibold text-blue-800 mb-2">System Status</h3>
              <p className="text-sm text-blue-700">✅ PostgreSQL verbunden</p>
              <p className="text-sm text-blue-700">✅ Frontend aktiv</p>
              <p className="text-sm text-blue-700">🕐 {currentTime}</p>
            </div>
            
            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
              <h3 className="font-semibold text-green-800 mb-2">Datenbank</h3>
              <p className="text-sm text-green-700">Host: localhost:7010</p>
              <p className="text-sm text-green-700">DB: dentalytics</p>
              <p className="text-sm text-green-700">Status: Bereit</p>
            </div>
            
            <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
              <h3 className="font-semibold text-purple-800 mb-2">Services</h3>
              <p className="text-sm text-purple-700">Frontend: Port 7012</p>
              <p className="text-sm text-purple-700">Prisma: Port 7013</p>
              <p className="text-sm text-purple-700">Traefik: Aktiv</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Praxis-Analytics</h2>
            <div className="space-y-3">
              <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                <span className="text-gray-700">Patientenbesuche heute</span>
                <span className="font-semibold text-blue-600">23</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                <span className="text-gray-700">Behandlungen diese Woche</span>
                <span className="font-semibold text-green-600">147</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-gray-50 rounded">
                <span className="text-gray-700">Auslastung</span>
                <span className="font-semibold text-purple-600">89%</span>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Aktuelle Termine</h2>
            <div className="space-y-3">
              <div className="flex justify-between items-center p-3 bg-blue-50 rounded">
                <div>
                  <p className="font-medium text-gray-800">Max Mustermann</p>
                  <p className="text-sm text-gray-600">Kontrolle</p>
                </div>
                <span className="text-sm text-blue-600">14:30</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-green-50 rounded">
                <div>
                  <p className="font-medium text-gray-800">Anna Schmidt</p>
                  <p className="text-sm text-gray-600">Prophylaxe</p>
                </div>
                <span className="text-sm text-green-600">15:15</span>
              </div>
              <div className="flex justify-between items-center p-3 bg-yellow-50 rounded">
                <div>
                  <p className="font-medium text-gray-800">Peter Weber</p>
                  <p className="text-sm text-gray-600">Füllung</p>
                </div>
                <span className="text-sm text-yellow-600">16:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Quick Actions</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <button className="p-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              Neuer Patient
            </button>
            <button className="p-4 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors">
              Termin buchen
            </button>
            <button className="p-4 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors">
              Behandlung dokumentieren
            </button>
            <a href="http://85.215.196.176:7013" className="p-4 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-center">
              Datenbank verwalten
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrototypePage;
